// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_28ocNP6p79FL5mo14W", // nfsw
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/00gcNFcbI9VA1os6pg", // nsfw

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "NSFW Detector AI 🚫",
    HOME_PAGE_TITLE: "Home - NSFW Detector AI 🚫",
    DASHBOARD_PAGE_TITLE: "Home - NSFW Detector AI 🚫",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to NSFW Detector AI 🚫",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to detect NSFW images, choose an image and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "nsfw_img_detect_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/nsfw-img-detect-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;